import React from 'react';
import { Filter, ListFilter } from 'lucide-react';
import SecondaryButton from '../buttons/SecondaryButton';
import CancelButton from '../buttons/CustomCancelButton';
import { t } from '../../../locales/translate';
import './GenericFilter.css';
// Main Filter Component with Show/Hide Toggle
const GenericFilter = ({ showFilters, toggleFilters }) => {
  return (
    <div className="filter-toggle-wrapper" style={{ display: 'flex', alignItems: 'center'}}>
      <div className="filter-divider"  style={{
        width: '1px',
        height: '24px',
        backgroundColor: '#e0e0e0',
        marginRight: document.body.dir === 'rtl' ? '0' : '12px',
        marginLeft: document.body.dir === 'rtl' ? '12px' : '0',
      }}></div>
      <SecondaryButton
        onClick={toggleFilters}
        text={
          <span style={{fontFamily: 'poppins', fontSize: '14px', fontWeight: 500}}>
          {showFilters ? `${t("hide")}` : `${t("filters")}`} 
          </span>
            }
        icon={ListFilter}
        width="18px"
        height="26px"
      />
    </div>
  );
};
export const FilterBar = ({
  showFilters,
  children,
  onClearAll,
  clearAllText = `${t("clearAll")}`,
  showClearAll = true
}) => {
  if (!showFilters) return null; 

  return (
    <div className="filter-bar-container">
      <div className="filter-controls-wrapper">{children}</div>

      {showClearAll && (
        <div className="filter-clear-all-wrapper">
          <CancelButton width="99px" onClick={onClearAll} text={clearAllText} />
        </div>
      )}
    </div>
  );
};

export default GenericFilter;